import { ReactComponent as CartSvg } from '../../assets/icons/cart.svg';

export const CartIcon: SvgIcon = (props) => {
    return <CartSvg {...props} />;
};
